import { render, staticRenderFns } from "./BGrid.vue?vue&type=template&id=a5a22266&"
import script from "./BGrid.vue?vue&type=script&lang=js&"
export * from "./BGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports